import { React, useState, useEffect } from "react";
import classnames from "classnames";
import {
  Button,
  Navbar,
  Container,
  Progress,
  Card,
  CardBody,
} from "reactstrap";
import { useLocation, useHistory } from "react-router-dom";
import { logout } from "components/Services/authService";

import { faUsers, faUserPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { Tooltip as ReactTooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";

import { faTriangleExclamation } from "@fortawesome/free-solid-svg-icons";

function AdminNavbar(props) {
  const [collapseOpen, setCollapseOpen] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [color, setColor] = useState("navbar-transparent");
  const location = useLocation();

  const [naAlarms, setNaalarms] = useState(0);
  const [mnAlarms, setMnAlarms] = useState(0);
  const [mjAlarms, setMjAlarms] = useState(0);
  const [crAlarms, setCrAlarms] = useState(0);
  const [warningMessage, setWarningMessage] = useState(0);
  const [errorMessage, setErrorMessage] = useState(0);

  const [taskProgress, setTaskProgress] = useState(100);
  const [taskProgressDelay, setTaskProgressDelay] = useState(10000);

  useEffect(() => {
    fetchAlarmData();

    const intervalIDValue = setInterval(() => {
      fetchAlarmData();
    }, 15000);

    return () => {
      clearInterval(intervalIDValue);
    };
  }, []);

  useEffect(() => {
    const intervalIDValue = setInterval(() => {
      fetchTaskData();
    }, taskProgressDelay);

    return () => {
      clearInterval(intervalIDValue);
    };
  }, [taskProgressDelay]);

  useEffect(() => {
    const intervalIDValue = setInterval(() => {
      fetchGeneralData();
    }, 300000);

    return () => {
      clearInterval(intervalIDValue);
    };
  }, []);

  const fetchAlarmData = () => {
    const start = Date.now();
    fetch("/api/v1/alarm/summary", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        sessionId: sessionStorage.getItem("sessionId"),
      },
    })
      .then((response) => {
        if (!response.ok) {
          if (response.status === 401) {
            logout();
          }
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((actualData) => {
        setNaalarms(0);
        setMnAlarms(0);
        setMjAlarms(0);
        setCrAlarms(0);
        setWarningMessage(actualData.data.warningMessage);
        setErrorMessage(actualData.data.errorMessage);
        for (var i = 0; i < actualData.data.alarmSummary.length; i++) {
          if (actualData.data.alarmSummary[i].severity.toUpperCase() == "NA") {
            setNaalarms(actualData.data.alarmSummary[i].count);
          } else if (
            actualData.data.alarmSummary[i].severity.toUpperCase() == "MN"
          ) {
            setMnAlarms(actualData.data.alarmSummary[i].count);
          } else if (
            actualData.data.alarmSummary[i].severity.toUpperCase() == "MJ"
          ) {
            setMjAlarms(actualData.data.alarmSummary[i].count);
          } else if (
            actualData.data.alarmSummary[i].severity.toUpperCase() == "CR"
          ) {
            setCrAlarms(actualData.data.alarmSummary[i].count);
          }
        }
      })
      .catch((err) => {
        console.log(err.message);
      });
  };

  const fetchGeneralData = () => {
    fetch("/api/v1/auth/general", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        sessionId: sessionStorage.getItem("sessionId"),
      },
    })
      .then((response) => response.json())
      .then((actualData) => {
        sessionStorage.setItem("licenseTypes", actualData.data.licenseTypes);
      })
      .catch((err) => {
        console.log(err.message);
      });
  };

  const fetchTaskData = () => {
    fetch("/api/v1/task/list/pending", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        sessionId: sessionStorage.getItem("sessionId"),
      },
    })
      .then((response) => response.json())
      .then((actualData) => {
        if (actualData.status == 200) {
          const newProgress = actualData.data;
          setTaskProgress(newProgress);
          if (newProgress < 100) {
            setTaskProgressDelay(2500);
          } else {
            setTaskProgressDelay(10000);
          }
        }
      })
      .catch((err) => {
        console.log(err.message);
      });
  };

  useEffect(() => {
    if (
      window.outerWidth < 993 &&
      document.documentElement.className.indexOf("nav-open") !== -1
    ) {
      document.documentElement.classList.toggle("nav-open");
    }
  }, [location]);

  const history = useHistory();

  const redirectToAlarmPage = (severity) => {
    const location = {
      pathname: "/admin/alarms/severity",
      state: { params: severity },
    };
    history.push(location);
  };

  const redirectToTaskList = () => {
    const location = {
      pathname: "/admin/tasks/list",
    };
    history.push(location);
  };

  const redirectToSubscriberPage = () => {
    const location = {
      pathname: "/admin/subscribers/list",
    };
    history.push(location);
  };

  const redirectToSubscriberCreate = () => {
    const location = {
      pathname: "/admin/subscribers/edit",
    };
    history.push(location);
  };

  // this function opens and closes the sidebar on small devices
  const toggleSidebar = () => {
    document.documentElement.classList.toggle("nav-open");
    setSidebarOpen(!sidebarOpen);
  };

  const getFontColor = (value) => {
    if (value > 0) {
      return "#FFFFFF";
    } else {
      return "#4080b0";
    }
  };

  const getBackgroundColor = (defaultColor, value) => {
    if (value > 0) {
      return defaultColor;
    } else {
      return "#bdc3c7";
    }
  };

  return (
    <>
      <Navbar className={classnames("navbar-sticky", color)} expand="lg">
        <Container fluid>
          <div
            className="navbar-wrapper"
            style={{ justifyContent: "flex-end", width: "100%" }}
          >
            <div className="navbar-minimize"></div>
            <div style={{ display: "flex", gap: "10px", marginLeft: "20px" }}>
              <>
                <Button
                  className="btn-round-top-bar subscriberListElement"
                  color="info"
                  onClick={() => redirectToSubscriberPage()}
                >
                  <FontAwesomeIcon
                    icon={faUsers}
                    style={{ fontSize: "1.7em" }}
                  />
                </Button>
                <ReactTooltip
                  anchorSelect=".subscriberListElement"
                  place="bottom"
                  style={{ textAlign: "left", zIndex: "100" }}
                >
                  Subscribers
                </ReactTooltip>
              </>
              <>
                <Button
                  className="btn-round-top-bar subscriberCreateElement"
                  color="info"
                  onClick={() => redirectToSubscriberCreate()}
                >
                  <FontAwesomeIcon
                    icon={faUserPlus}
                    style={{ fontSize: "1.7em" }}
                  />
                </Button>
                <ReactTooltip
                  anchorSelect=".subscriberCreateElement"
                  place="bottom"
                  style={{ textAlign: "left", zIndex: "100" }}
                >
                  Create Subscriber
                </ReactTooltip>
              </>
            </div>
            {taskProgress < 100 ? (
              <div
                style={{
                  marginLeft: "auto",
                  width: "400px",
                }}
              >
                <Card
                  style={{ margin: "0px", padding: "0px", cursor: "pointer" }}
                  onClick={() => redirectToTaskList()}
                >
                  <CardBody
                    style={{
                      margin: "0px 5px 0px 5px",
                      padding: "5px 15px 5px 15px",
                    }}
                  >
                    <div className="d-flex align-items-center">
                      <Progress
                        value={taskProgress}
                        max={100}
                        color="primary"
                        striped
                        animated
                        style={{
                          height: "8px",
                          borderRadius: "5px",
                        }}
                        className="w-100"
                      />
                      <span className="ms-2 text-muted">{taskProgress}%</span>
                      {warningMessage || errorMessage ? (
                        <span style={{ marginLeft: "10px" }}>
                          <a className="licenseWarning">
                            <FontAwesomeIcon
                              icon={faTriangleExclamation}
                              style={{ color: "orange" }}
                            />
                          </a>
                          <ReactTooltip
                            anchorSelect=".licenseWarning"
                            place="bottom"
                            style={{ textAlign: "left", zIndex: "100" }}
                          >
                            {warningMessage} <br />
                            {errorMessage}
                          </ReactTooltip>
                        </span>
                      ) : (
                        ""
                      )}
                    </div>
                  </CardBody>
                </Card>
              </div>
            ) : (
              ""
            )}
            {taskProgress >= 100 && warningMessage ? (
              <div
                style={{
                  marginLeft: "auto",
                  backgroundColor: "lightyellow",
                  fontSize: "16px",
                  border: "3px solid grey",
                  padding: "4px 50px",
                  fontWeight: "bold",
                }}
              >
                {warningMessage}
              </div>
            ) : (
              ""
            )}
            {taskProgress >= 100 && errorMessage ? (
              <div
                style={{
                  marginLeft: "auto",
                  backgroundColor: "lightsalmon",
                  fontSize: "16px",
                  border: "3px solid grey",
                  padding: "4px 50px",
                  fontWeight: "bold",
                }}
              >
                {errorMessage}
              </div>
            ) : (
              ""
            )}
            <div
              style={{
                marginLeft: "auto",
              }}
            >
              CR{" "}
              <div
                className="alarm"
                style={{
                  cursor: "pointer",
                  display: "inline-block",
                  marginRight: "10px",
                  backgroundColor: getBackgroundColor("#e8504d", crAlarms),
                }}
                onClick={() => redirectToAlarmPage("severity||cr")}
              >
                <a style={{ fontSize: "18px", color: getFontColor(crAlarms) }}>
                  {crAlarms}
                </a>
              </div>
              MJ{" "}
              <div
                className="alarm"
                style={{
                  cursor: "pointer",
                  display: "inline-block",
                  marginRight: "10px",
                  backgroundColor: getBackgroundColor("#ed9131", mjAlarms),
                }}
                onClick={() => redirectToAlarmPage("severity||mj")}
              >
                <a style={{ fontSize: "18px", color: getFontColor(mjAlarms) }}>
                  {mjAlarms}
                </a>
              </div>
              MN{" "}
              <div
                className="alarm"
                style={{
                  cursor: "pointer",
                  display: "inline-block",
                  marginRight: "10px",
                  backgroundColor: getBackgroundColor("#f0cd66", mnAlarms),
                }}
                onClick={() => redirectToAlarmPage("severity||mn")}
              >
                <a style={{ fontSize: "18px", color: getFontColor(mnAlarms) }}>
                  {mnAlarms}
                </a>
              </div>
              NA{" "}
              <div
                className="alarm"
                style={{
                  cursor: "pointer",
                  display: "inline-block",
                  backgroundColor: getBackgroundColor("#95b3d7", naAlarms),
                }}
                onClick={() => redirectToAlarmPage("severity||na")}
              >
                <a style={{ fontSize: "18px", color: getFontColor(naAlarms) }}>
                  {naAlarms}
                </a>
              </div>
            </div>
          </div>
        </Container>
      </Navbar>
    </>
  );
}

export default AdminNavbar;
